<template>
    <b-row>
        <b-col>
            <div class="mb-2 d-flex" style="gap: .5rem;">
                <v-select v-model="attr_id" :reduce="obj => obj.id" label="name" :options="attrs_visible" clearSearchOnSelect clearable required placeholder="Ценообразующий фактор" style="flex: 1;" />
                <b-button v-if="attr_id != null" size="sm" variant="outline-primary" v-on:click="() => add_attr()"><base-icon name="add"/></b-button>
            </div>

            <factors_table :controller="controller"
                :data="showed_attrs"
                @refresh_plot="refresh_plot" @delete_attr="delete_attr" :is_analogues="is_sales"
            />
        </b-col>

        <b-col v-if="plot" class="factors-plot">
            <div class="factors-plot_nav">
                <v-select class="factors-plot_select" v-if="plot_type == 'number'" v-model="plot_number_type" :options="plot_number_options" :clearable="false" />
            </div>

            <div class="factors-plot_plot">
                <GChart v-if="plot_type == 'number'" type="ColumnChart" :settings="{ packages: [ 'corechart' ], language: 'en' }" :options="column_options"
                    :data="plot_number_type == 'Статистика' ? plot : plot_number"
                />
                <GChart v-else type="PieChart" :settings="{ packages: [ 'corechart' ], language: 'ru' }" :options="pie_options" :data="plot"/>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import api from '../../../../../../api';
import attrs from '../../../../../../api/attrs';
import Reference_controller from '../controller';
import factors_table from './table';
import { GChart } from "vue-google-charts"

export default {
    props :
	{
		controller : Reference_controller,
        is_sales : Boolean,
	},

    components :
    {
        GChart,
        factors_table,
    },

    data() {
        return {
            attrs: [],
            attrs_visible: [],
            showed_attrs: [],
            attr_id: null,

            plot: null,
            plot_type: null,
            plot_number : null,
            plot_number_options : [ "Статистика", "Количество объектов" ],
            plot_number_type : "Статистика",
            
            column_options :
			{
				legend : { position : "none" },
				annotations : { alwaysOutside : true },
				vAxis : { format: "#" },
				hAxis : { format: "#" },
                chartArea : { width : "90%", height : "80%" },
				tooltip: { isHtml: true }
			},
            pie_options :
            {
                legend : { position : "right" },
                chartArea : { width : "90%", height : "90%" },
				tooltip: { isHtml: true }
            }
			// attr_stat_pie_options : { legend : { position : "right", textStyle : { fontSize : 14 } }, chartArea : { width : "100%", height : "90%" }},
        }
    },

    beforeMount()
	{
        attrs.get(this).then(
            desc =>
            {
                this.attrs = desc.attrs.filter(attr =>
                    ! attr.not_real
                    && attr.is_factor
                    && (
                        attr.type == "number"
                        || (
                            attr.name != "bad"
                            && attr.type == "bool"
                        )
                        || (
                            attr.type == "str"
                        )
                    )
                )
                this.update_attrs_visible()
            }
        )
    },

    mounted()
    {
        if (this.is_sales)
        {
            this.controller.set_stat((({ stat, calc_stat }) => {
                this.showed_attrs = [
                    ...stat.map((attr) => ({ ...attr, not_editable : true })),
                    ...calc_stat
                ]

                if (this.attrs)
                {
                    this.update_attrs_visible()
                }
            }))
        }
        else
        {
            this.controller.set_stat((({ stat }) => {
                this.showed_attrs = stat

                if (this.attrs)
                {
                    this.update_attrs_visible()
                }
            }))
        }
    },

    methods :
    {
        update_attrs_visible()
        {
            this.attrs_visible = this.attrs.filter(attr => 
                this.showed_attrs.find(sattr => attr.id == sattr.id) == null
            )
        },

        add_attr()
		{
            if (this.is_sales)
            {
                this.controller.add_calc_factor(this.attr_id)
            }
            else
            {
                this.controller.add_factor(this.attr_id)
            }

            this.attr_id = null
        },

        delete_attr(attr_id)
        {
            if (this.is_sales)
            {
                this.controller.delete_calc_factor(attr_id)
            }
            else
            {
                this.controller.delete_factor(attr_id)
            }
        },

        get_row(name, value)
        {
            return [ name, value, value, api.get_tooltip(name, "Значение", `${value}`) ]
        },

        refresh_plot(attr) {
            this.plot = null
            this.plot_type = null

            if (!attr || attr.histogram == null)
            {
                return
            }
            else if (attr.type == "number")
            {
                const object_type_data = []
    
                Object.values(attr.histogram).forEach(
                    desc =>
                    {
                        const value = desc[0]
                        const count = desc[1]
    
                        object_type_data.unshift([ value, count, api.get_tooltip(value, "Количество объектов", `${count}`) ])
                    })

                this.plot_type = "number"
                this.plot_number = [ [ "Значение", "Количество объектов", { role : "tooltip", p: {html: true} } ], ...object_type_data ]

                this.plot = [
                    [ "Статистика", "Значение", { role : "annotation", type : "string" }, { role : "tooltip", p: {html: true} } ],
                    this.get_row("Минимум", attr.min),
                    this.get_row("Медиана", attr.median),
                    this.get_row("Среднее", attr.average),
                    this.get_row("Средневзвешенное", attr.weighted_average),
                    this.get_row("Максимум", attr.max),
                ]
            }
            else
            {
                const object_type_data = []
    
                Object.values(attr.histogram).forEach(
                    desc =>
                    {
                        const value = api.format_value_empty(desc[0])
                        const count = desc[1]
                        const percent = api.round2(( 100. * count ) / attr.count)
                        const label = `${percent} % - ${value}`
    
                        object_type_data.push([ label, count, api.get_tooltip(label, "", `${count} (${percent}%)`) ])
                    })
                this.plot = [ [ "Значение", "Количество в процентах", { role : "tooltip", p: {html: true} } ], ...object_type_data ]
            }

            if (process.env.NODE_ENV !== 'production') {
                console.log({plot: this.plot, plot_number: this.plot_number})
            }
        }
    }
}
</script>

<style scoped>
.factors-plot
{
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.factors-plot_nav
{
    height: 32px;
}

.factors-plot_select
{
    width: 50%;
}

.factors-plot_plot
{
    flex: 1;
    display: flex;
    align-items: center;
}

.factors-plot_plot > div
{
    width: 100%;
    height: 300px;
}
</style>
